export const REPORT_PATHS = {
  ALL_TASKS: 'all-tasks',
  LATE_TASKS: 'late-tasks',
  ALL_MILESTONES: 'all-milestones',
  TIMELINE: 'timeline',
  TIME_TRACKING: 'time-tracking',
  USAGE: 'usage-report',
  KEY_MILESTONES: 'key-milestones',
}
